import React from 'react';
import RootRenderer from './dynamic-components/RootRenderer';
import FieldPanelRenderer from './dynamic-components/FieldPanelRenderer';
import KeyValueTableRenderer from './dynamic-components/KeyValueTableRenderer';
import FilesListRenderer from './dynamic-components/FilesListRenderer';
import ImageRenderer from './dynamic-components/ImageRenderer';

interface Props {
  schema: any;
}

const typenameToComponentsMap = new Map<string, React.FC<any>>([
  ['root', RootRenderer],
  ['fieldPanel', FieldPanelRenderer],
  ['keyValueTable', KeyValueTableRenderer],
  ['filesList', FilesListRenderer],
  ['image', ImageRenderer],
]);

/**
 * Paired renderer: renders the version-comparison layout once, emitting a left + right cell per field
 * into a shared CSS grid so corresponding fields stay vertically aligned across both versions.
 */
const ComparisonRenderer: React.FC<Props> = ({ schema }) => {
  if (Array.isArray(schema)) {
    return <>{schema.map((el, i) => <ComparisonRenderer key={i} schema={el} />)}</>;
  }

  const typename = schema.__typename;
  if (!typename) {
    throw new Error(`Schema doesn't have __typename: "${JSON.stringify(schema)}"`);
  }

  const component = typenameToComponentsMap.get(typename);
  if (!component) {
    throw new Error(`Comparison component for __typename "${typename}" doesn't exist.`);
  }

  return React.createElement(component, schema);
};

export default ComparisonRenderer;
